export const USER_LOADING = "USER_LOADING";
export const USER_LOADED = "USER_LOADED";
export const USER_LOAD_CANCELED = "USER_LOAD_CANCELED";
export const AUTH_ERROR = "AUTH_ERROR";
export const CREATE_MESSAGE = "CREATE_MESSAGE";
export const CLEAR_ALERT = "CLEAR_ALERT";
export const CREATE_GENERIC_ERROR_ALERT = "CREATE_GENERIC_ERROR_ALERT";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const VERIFY_SUCCESS = 'VERIFY_SUCCESS';
export const CLEAR_REGISTRATION = 'CLEAR_REGISTRATION';
export const ACTIVATE_SUCCESS = 'ACTIVATE_SUCCESS';
export const ACTIVATE_FAIL = 'ACTIVATE_FAIL';
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAIL = "LOGOUT_FAIL";
export const EXTERNAL_ACTION = "EXTERNAL_ACTION";
export const GET_COMPANIES = "GET_COMPANIES";
export const GET_INDUSTRIES = "GET_INDUSTRIES";
export const GET_SEARCHABLE_COMPANIES = "GET_SEARCHABLE_COMPANIES";
export const GET_COMPANY = "GET_COMPANY";
export const CREATE_COMPANY = "CREATE_COMPANY";
export const EDIT_COMPANY = "EDIT_COMPANY";
export const EDIT_USER = "EDIT_USER";
export const UPLOAD_USER_ICON = "UPLOAD_USER_ICON";
export const DELETE_COMPANY = "DELETE_COMPANY";
export const ARCHIVE_COMPANY = "ARCHIVE_COMPANY";
export const GET_PROJECTS = "GET_PROJECTS";
export const GET_PROJECTS_INCLUDING_HIDDEN = "GET_PROJECTS_INCLUDING_HIDDEN";
export const GET_PROJECTS_DROPS = "GET_PROJECTS_DROPS";
export const SET_PROJECT_DROP = "SET_PROJECT_DROP";
export const SET_PROJ_HIDDEN_HIDE = "SET_PROJ_HIDDEN_HIDE";
export const SET_PROJ_HIDDEN = "SET_PROJ_HIDDEN";
export const SET_PROJ_VISIBLE = "SET_PROJ_VISIBLE";
export const TOGGLE_SHOW_HIDDEN_PROJECTS = "TOGGLE_SHOW_HIDDEN_PROJECTS";
export const GET_COMPANY_PROJECTS = "GET_COMPANY_PROJECTS";
export const GET_PROJECTS_OUTGOING = "GET_PROJECTS_OUTGOING";
export const GET_PROJECT_FAVORITES = "GET_PROJECT_FAVORITES";
export const ADD_PROJECT_FAVORITE = "ADD_PROJECT_FAVORITE";
export const REMOVE_PROJECT_FAVORITE = "REMOVE_PROJECT_FAVORITE";
export const GET_PROJECT = "GET_PROJECT";
export const CLEAR_PROJECT = "CLEAR_PROJECT";
export const CLEAR_PROJECTS = "CLEAR_PROJECTS";
export const CREATE_PROJECT = "CREATE_PROJECT";
export const EDIT_PROJECT = "EDIT_PROJECT";
export const DELETE_PROJECT = "DELETE_PROJECT";
export const ARCHIVE_PROJECT = "ARCHIVE_PROJECT";
export const SET_PROJECT_VIEWERS = "SET_PROJECT_VIEWERS";
export const GET_INVITE_DETAIL = "GET_INVITE_DETAIL";
export const SET_COMPANY_INVITES = "SET_COMPANY_INVITES";
export const GET_EX_ACCEPTED_CONTRACT = "GET_EX_ACCEPTED_CONTRACT";
export const GET_NEW_ACCEPTED_CONTRACT = "GET_NEW_ACCEPTED_CONTRACT";
export const GET_CONTRACT = "GET_CONTRACT";
export const GET_CONTRACTS = "GET_CONTRACTS";
export const GET_CONTRACTS_INCLUDING_HIDDEN = "GET_CONTRACTS_INCLUDING_HIDDEN";
export const GET_CONTRACT_DROPS = "GET_CONTRACT_DROPS";
export const SET_CONTRACT_DROP = "SET_CONTRACT_DROP";
export const GET_CONTRACTS_OUTGOING = "GET_CONTRACTS_OUTGOING";
export const CLEAR_CONTRACTS_OUTGOING = "CLEAR_CONTRACTS_OUTGOING";
export const GET_PROJECT_CONTRACTS = "GET_PROJECT_CONTRACTS";
export const GET_PROJECT_CONTRACTS_OUTGOING = "GET_PROJECT_CONTRACTS_OUTGOING";
export const GET_CONTRACT_INVITATIONS = "GET_CONTRACT_INVITATIONS";
export const GET_CONTRACT_INVITATION_COUNT = "GET_CONTRACT_INVITATION_COUNT";
export const RESPOND_TO_CONTRACT_INVITATION = "RESPOND_TO_CONTRACT_INVITATION";
export const CLEAR_INVITATIONS = "CLEAR_INVITATIONS";
export const EDIT_CONTRACT = "EDIT_CONTRACT";
export const CREATE_CONTRACT = "CREATE_CONTRACT";
export const DELETE_CONTRACT = "DELETE_CONTRACT";
export const CLEAR_CONTRACT = "CLEAR_CONTRACT";
export const CLEAR_CONTRACTS = "CLEAR_CONTRACTS";
export const GET_USER_BY_EMAIL = "GET_USER_BY_EMAIL";
export const GET_PCA_BY_EMAIL = "GET_PCA_BY_EMAIL";
export const GET_VCA_BY_EMAIL = "GET_VCA_BY_EMAIL";
export const GET_AR_BY_EMAIL = "GET_AR_BY_EMAIL"; 
export const GET_AP_BY_EMAIL = "GET_AP_BY_EMAIL";
export const GET_APP1_BY_EMAIL = "GET_APP1_BY_EMAIL";
export const GET_APP2_BY_EMAIL = "GET_APP2_BY_EMAIL";
export const GET_INVOICES = "GET_INVOICES";
export const GET_INVOICES_INCLUDING_HIDDEN = "GET_INVOICES_INCLUDING_HIDDEN";
export const GET_INCOMING_INVOICES = "GET_INCOMING_INVOICES";
export const GET_OUTGOING_INVOICES = "GET_OUTGOING_INVOICES";
export const GET_INVOICE_DROPS = "GET_INVOICE_DROPS";
export const SET_INVOICE_DROP = "SET_INVOICE_DROP";
export const GET_INVOICE = "GET_INVOICE";
export const GET_INVOICE_HISTORY = "GET_INVOICE_HISTORY";
export const GET_INVOICE_VERSIONS = "GET_INVOICE_VERSIONS";
export const GET_INVOICE_VERSION_DETAIL = "GET_INVOICE_VERSION_DETAIL";
export const CLEAR_INVOICE_VERSION_DETAIL = "CLEAR_INVOICE_VERSION_DETAIL";
export const CLEAR_INVOICES = "CLEAR_INVOICES";
export const CLEAR_INVOICE_ATTACHMENTS = "CLEAR_INVOICE_ATTACHMENTS";
export const GET_INVOICE_WITHOUT_ATTACHMENTS = "GET_INVOICE_WITHOUT_ATTACHMENTS";
export const CLEAR_INVOICE = "CLEAR_INVOICE";
export const DELETE_INVOICE = "DELETE_INVOICE";
export const SEND_NEW_INVOICE = "SEND_NEW_INVOICE";
export const SAVE_NEW_INVOICE_DRAFT = "SAVE_NEW_INVOICE_DRAFT";
export const SEND_EX_INVOICE = "SEND_EX_INVOICE";
export const SAVE_EX_INVOICE_DRAFT = "SAVE_EX_INVOICE_DRAFT";

export const TOGGLE_INVOICE_TAB = "TOGGLE_INVOICE_TAB";
export const RESPOND_TO_INVOICE = "RESPOND_TO_INVOICE";
export const START_INVOICE_REVISION = "START_INVOICE_REVISION";
export const GET_USER_ICON_PATH = "GET_USER_ICON_PATH";
export const GET_PEOPLE_BY_PROJECTS = "GET_PEOPLE_BY_PROJECTS";
export const GET_PEOPLE_BY_PROJECT = "GET_PEOPLE_BY_PROJECT";
export const GET_PEOPLE_BY_COMPANY = "GET_PEOPLE_BY_COMPANY";
export const GET_PEOPLE_BY_REQUESTS = "GET_PEOPLE_BY_REQUESTS";
export const GET_PEOPLE_BY_REQUEST_COUNT = "GET_PEOPLE_BY_REQUEST_COUNT";
export const SELECT_PERSON = "SELECT_PERSON";
export const CLEAR_PEOPLE = "CLEAR_PEOPLE";
export const UPDATE_USER_COMPANY_ROLE = "UPDATE_USER_COMPANY_ROLE";
export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";
export const READ_NOTIFICATION = "READ_NOTIFICATION";
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const SET_SIDEBAR_PAGE = "SET_SIDEBAR_PAGE";
export const RESPOND_TO_REG_COMPANY_INVITATION = "RESPOND_TO_REG_COMPANY_INVITATION";
export const UPDATE_INVOICE_ATTACHMENTS = "UPDATE_INVOICE_ATTACHMENTS";
export const UPDATE_INVOICE_ATTACHMENTS_ADDITIONAL = "UPDATE_INVOICE_ATTACHMENTS_ADDITIONAL";
export const UPDATE_CONTRACT_ATTACHMENTS = "UPDATE_CONTRACT_ATTACHMENTS";
export const GET_REG_COMPANY_INVITATIONS = "GET_REG_COMPANY_INVITATIONS";
export const GET_DASHBOARD = "GET_DASHBOARD";
export const CLEAR_ALL_DROPS = "CLEAR_ALL_DROPS";

export const GET_APPROVAL_WORKFLOWS = "GET_APPROVAL_WORKFLOWS";
export const GET_APPROVAL_WORKFLOW = "GET_APPROVAL_WORKFLOW";
export const CREATE_APPROVAL_WORKFLOW = "CREATE_APPROVAL_WORKFLOW";
export const EDIT_APPROVAL_WORKFLOW = "EDIT_APPROVAL_WORKFLOW";
export const DELETE_APPROVAL_WORKFLOW = "DELETE_APPROVAL_WORKFLOW";
export const GET_APPROVAL_WORKFLOW_STAGES = "GET_APPROVAL_WORKFLOW_STAGES";
export const SAVE_APPROVAL_WORKFLOW_STAGES = "SAVE_APPROVAL_WORKFLOW_STAGES";
export const GET_WORKFLOW_STAGE_TYPES = "GET_WORKFLOW_STAGE_TYPES";
export const DELETE_WORKFLOW_STAGE_TYPE = "DELETE_WORKFLOW_STAGE_TYPE";
export const CLEAR_APPROVAL_WORKFLOW = "CLEAR_APPROVAL_WORKFLOW";

export const GET_QUOTES = "GET_QUOTES";
export const GET_QUOTE = "GET_QUOTE";
export const CREATE_QUOTE = "CREATE_QUOTE";
export const EDIT_QUOTE = "EDIT_QUOTE";
export const SEND_QUOTE = "SEND_QUOTE";
export const RESPOND_TO_QUOTE = "RESPOND_TO_QUOTE";
export const CONVERT_QUOTE = "CONVERT_QUOTE";
export const DELETE_QUOTE = "DELETE_QUOTE";
export const CLEAR_QUOTE = "CLEAR_QUOTE";